/**
 * React Email Builder logo — minimal envelope with code nodes.
 * Inline SVG for zero-latency render (no HTTP request).
 */
export function LogoMark({ className = "h-7 w-7" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="6" fill="#0f172a" />
      <path d="M7 13l9 5 9-5" stroke="#7dd3fc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 13v7a1 1 0 001 1h14a1 1 0 001-1v-7" stroke="#7dd3fc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 13l9-5 9 5" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 18v-5" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M20 10.5l3.5-2" stroke="#0ea5e9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 10.5l-3.5-2" stroke="#0ea5e9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="24" cy="8" r="1.5" fill="#0ea5e9" />
      <circle cx="8" cy="8" r="1.5" fill="#0ea5e9" />
    </svg>
  );
}

export function LogoMarkLight({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="6" fill="white" />
      <path d="M7 13l9 5 9-5" stroke="#7dd3fc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 13v7a1 1 0 001 1h14a1 1 0 001-1v-7" stroke="#0f172a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 13l9-5 9 5" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 18v-5" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M20 10.5l3.5-2" stroke="#0ea5e9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 10.5l-3.5-2" stroke="#0ea5e9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="24" cy="8" r="1.5" fill="#0ea5e9" />
      <circle cx="8" cy="8" r="1.5" fill="#0ea5e9" />
    </svg>
  );
}